// "Procedure codes" cells: codes are short, so they never truncate, and exactly two show side by
// side; with more, one code and "+N".
export const CODE_CHIP_PARAMS = { showAllUpTo: 2, chipClassName: 'shrink-0' };
